<template>
  <div class="login">
    <div class="header">
      <div class="header-name">
        <div>{{ i18nCompetitionName }}</div>
        <div class="register-time">
          <i class="el-icon-time time-icon"></i>
          {{ $t('login.registerTime') }}: {{competitionInfo.registerStartTime}} - {{competitionInfo.registerEndTime}}
        </div>
      </div>
      <div class="header-logo">
        <div class="logo-img" v-if="competitionInfo.logo1"><img :src="define.previewNginxUrl + competitionInfo.logo1"/></div>
        <div class="logo-img" v-if="competitionInfo.logo2"><img :src="define.previewNginxUrl + competitionInfo.logo2"/></div>
        <div class="logo-img" v-if="competitionInfo.logo3"><img :src="define.previewNginxUrl + competitionInfo.logo3"/></div>
        <LangSwitcher />
      </div>
    </div>
    <div class="center">
      <div class="login-form">
        <div class="login-top">{{ $t('login.userLogin') }}</div>
        <div class="login-btn">
          <div class="center-left">
            <div class="desc-block" v-if="competitionInfo.description">
              <div class="desc-title">
                <i class="el-icon-document desc-title-icon"></i>{{ $t('login.specialNote') }}
              </div>
              <div class="desc-content">{{ competitionInfo.description }}</div>
            </div>

            <div class="register-contact" v-for="group in groupedContactList" :key="group.name">
              <div class="contact-title">
                <i class="el-icon-s-custom contact-title-icon"></i>{{ group.name }}
              </div>
              <div class="contact-item" v-for="contactItem in group.contacts" :key="contactItem.id">
                <div class="contact-info">
                  <span class="contact-name">{{ contactItem.realName }}</span>
                  <span class="contact-info-tag">
                    <template v-if="contactItem.mobile"><i class="el-icon-phone-outline"></i>{{ contactItem.mobile }}</template>
                  </span>
                  <span class="contact-info-tag">
                    <template v-if="contactItem.email"><i class="el-icon-message"></i>{{ contactItem.email }}</template>
                  </span>
                  <span class="contact-info-tag">
                    <template v-if="contactItem.wechat"><i class="el-icon-chat-dot-round"></i>{{ contactItem.wechat }}</template>
                  </span>
                </div>
              </div>
            </div>

            <div class="file-down">
              <div class="file-down-title">{{ $t('login.fileDownload') }}</div>
              <div class="file-down-file" v-for="competitionFile in competitionInfo.fileList" :key="competitionFile.id">
                <el-button type="text" @click="downloadFile(competitionFile)">{{competitionFile.fileName}}</el-button>
              </div>
            </div>
          </div>
          <div class="center-right">
            <el-form :model="loginForm" :rules="ruleForm" ref="ruleForm" label="top" class="demo-ruleForm">
              <el-form-item :label="$t('login.account')" prop="account" class="custom-label" v-if="competitionInfo.registerModel === 1">
                <el-input v-model="loginForm.account" :placeholder="$t('login.placeholderAccount')" @keyup.enter.native="login('ruleForm')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('login.account')" prop="account" class="custom-label" v-if="competitionInfo.registerModel === 2">
                <el-select v-model="loginForm.account" :placeholder="$t('common.pleaseSelect')" filterable style="width: 100%">
                  <el-option v-for="item in userList" :key="item.userId" :label="item.account" :value="item.userId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('login.password')" prop="password" class="custom-label">
                <el-input v-model="loginForm.password" :placeholder="$t('login.placeholderPassword')" show-password @keyup.enter.native="login('ruleForm')"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button class="button" type="primary" @click="login()" :loading="loginLoading">{{ $t('login.login') }}</el-button>
              </el-form-item>
            </el-form>
            <div class="nav-links">
              <el-button type="text" @click="toRegister()" v-if="competitionInfo.registerModel === 1">{{ $t('login.goRegister') }}</el-button>
              <el-button type="text" @click="backToIndex()">{{ $t('login.backToIndex') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { login } from "@/api/user";
import md5 from "js-md5";
import {getCompetitionInfo, downloadCompetitionFile} from "@/api/competition";
import {listByCompetitionId} from "@/api/competitionUser";
import Footer from "@/components/Footer.vue";
import LangSwitcher from "@/components/LangSwitcher.vue";
export default {
  name: 'login',
  components: { Footer, LangSwitcher },
  computed: {
    // 赛事名称中英文
    i18nCompetitionName() {
      return this.$i18n.locale === 'zh-CN' ? this.competitionInfo.nameCh : (this.competitionInfo.nameEn || this.competitionInfo.nameCh);
    },
    // 按 functionId 分组联系人，分组名根据当前语言显示 functionNameCh 或 functionNameEn
    groupedContactList() {
      const list = this.competitionInfo.contactList || []
      const grouped = {}
      const isZh = this.$i18n.locale === 'zh-CN'
      list.forEach(item => {
        // 分组 key 使用 functionId 保证唯一性，value 中携带显示名称
        const key = item.functionId || 'other'
        if (!grouped[key]) {
          grouped[key] = {
            name: isZh ? (item.functionNameCh || '') : (item.functionNameEn || item.functionNameCh || ''),
            contacts: []
          }
        }
        grouped[key].contacts.push(item)
      })
      return grouped
    },
  },
  data() {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      loginLoading: false,
      // 赛事ID
      competitionId: '',
      // 赛事信息
      competitionInfo: {},
      // 账号列表
      userList: [],
      // 登录校验
      ruleForm: {
        account: [
          { required: true, message: this.$t('login.placeholderAccount'), trigger: "blur" },
        ],
        password: [
          { required: true, message: this.$t('login.placeholderPassword'), trigger: "blur"},
        ],
      }
    };
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
      this.findCompetitionInfo();
    }
  },
  mounted() {

  },
  methods: {
    // 下载文件（blob 方式，自定义保存文件名：赛事名称_文件名称）
    downloadFile(competitionFile) {
      downloadCompetitionFile({fileName: competitionFile.fileUrl}).then((res) => {
        // 后端异常时返回 json，按下载失败处理
        if (!res || res.type === 'application/json') {
          this.$message.error(this.$t('login.downloadFailed'));
          return;
        }
        const link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob([res]));
        link.download = this.downloadFileName(competitionFile);
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },
    // 下载文件名：赛事名称_文件名称.扩展名（扩展名取存储文件路径，避免重复拼接）
    downloadFileName(competitionFile) {
      const name = this.i18nCompetitionName + '_' + competitionFile.fileName;
      const fileUrl = competitionFile.fileUrl || '';
      const ext = fileUrl.lastIndexOf('.') > -1 ? fileUrl.substring(fileUrl.lastIndexOf('.')) : '';
      return ext && name.toLowerCase().endsWith(ext.toLowerCase()) ? name : name + ext;
    },
    // 返回首页
    backToIndex() {
      this.$router.push({ path: '/index' });
    },
    // 进入注册
    toRegister(){
      this.$router.push({ path: "/register?id=" + this.competitionId });
    },
    // 获取赛事信息
    findCompetitionInfo(){
      getCompetitionInfo(this.competitionId).then((res) => {
        this.competitionInfo = res.data;
        if (this.competitionInfo.registerModel === 2) {
          this.findCompetitionUserList();
        }
      });
    },
    // 获取账号列表
    findCompetitionUserList(){
      listByCompetitionId(this.competitionId).then((res) => {
        this.userList = res.data.list;
      });
    },
    // 登录
    login() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let account = this.loginForm.account;
          if (this.competitionInfo.registerModel === 2) {
            const user = this.userList.find(u => u.userId === this.loginForm.account);
            account = user ? user.account : '';
          }
          let params = {
            account: account,
            password: md5(this.loginForm.password),
            platform: 2,
            isLogin: 1
          };
          this.loginLoading = true;
          login(params).then((res) => {
            if (res.code === 200) {
              let data = res.data;
              localStorage.setItem("token", data.token);
              let isRegisterAdmin = data.isRegisterAdmin;
              localStorage.setItem("isRegisterAdmin", isRegisterAdmin);
              if (isRegisterAdmin === 0) {
                this.$router.push({path: "/home?id=" + this.competitionId});
              }
              if (isRegisterAdmin === 1) {
                this.$router.push({path: "/manager?id=" + this.competitionId});
              }
              this.loginLoading = false;
            } else {
              this.$message.error(res.msg);
              this.loginLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.login {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: url('../assets/image/home_bj.jpg') no-repeat;

  .header {
    width: 100%;
    height: 120px;
    background-color: #001c58;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-name{
      font-size: 30px;
      color: #FFFFFF;
      font-weight: 600;
      margin-left: 30px;
      line-height: 36px;
      letter-spacing: 2px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

      div:first-child {
        position: relative;
        padding-left: 14px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 24px;
          background: #409EFF;
          border-radius: 2px;
        }
      }
    }

    .register-time {
      font-size: 18px;
      background: #83b9f7;
      display: inline-flex;
      align-items: center;
      padding: 6px 18px;
      border-radius: 30px;
      font-weight: bold;
      margin-top: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

      .time-icon {
        color: #fff;
        margin-right: 8px;
        font-size: 18px;
      }
    }

    .header-logo {
      display: flex;
      align-items: center;

      /deep/ .lang-switcher {
        margin-right: 16px;
      }

      .logo-img{
        margin: 0 10px;

        img {
          border-radius: 50%;
          width: 100px;
          height: 100px;
        }
      }
    }
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;

    .login-form {
      width: 1000px;
      min-height: 560px;
      background-color: #ffffff;
      border-radius: 16px;
      padding: 0 35px;

    }

    .login-top {
      text-align: center;
      font-size: 30px;
      font-weight: 600;
      margin-top: 20px;
    }

    .login-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 450px;
      padding: 0 50px;

      .center-left {
        width: 460px;

        .desc-block {
          margin-bottom: 20px;
          padding: 16px 18px;
          background: #f8f9fc;
          border-radius: 8px;
          border-left: 3px solid #1E50AE;

          .desc-title {
            font-size: 16px;
            font-weight: 600;
            color: #1E50AE;
            margin-bottom: 10px;

            .desc-title-icon {
              margin-right: 6px;
            }
          }

          .desc-content {
            font-size: 13px;
            color: #666;
            line-height: 1.8;
            white-space: pre-wrap;
            word-break: break-all;
          }
        }

        .register-contact {
          margin-bottom: 20px;
          padding: 16px 18px;
          background: #f8f9fc;
          border-radius: 8px;
          border-left: 3px solid #1E50AE;

          .contact-title {
            font-size: 16px;
            font-weight: 600;
            color: #1E50AE;
            margin-bottom: 10px;

            .contact-title-icon {
              margin-right: 6px;
            }
          }

          .contact-item {
            padding: 8px 0;

            & + .contact-item {
              border-top: 1px dashed #e4e7ed;
            }

            .contact-info {
              display: grid;
              grid-template-columns: 60px 112px 1fr 92px;
              column-gap: 8px;
              align-items: center;

              .contact-name {
                font-size: 14px;
                font-weight: 600;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .contact-info-tag {
                font-size: 13px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                min-width: 0;

                i {
                  margin-right: 4px;
                  font-size: 13px;
                }
              }
            }
          }
        }

        .file-down {
          font-size: 18px;
          margin-top: 28px;

          .file-down-title{
            font-weight: 600;
            color: #1E50AE;
            padding: 12px 18px;
            background: #f8f9fc;
            border-radius: 8px;
            border-left: 3px solid #1E50AE;
          }

          .file-down-file {
            padding: 4px 22px;
            height: 30px;
            line-height: 30px;
          }
        }
      }

      .nav-links {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .center-right {
        width: 400px;

        .button {
          width: 100%;
          background-color: #1E50AE;
        }
      }
    }
  }
}

.custom-label {
  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #333;
  }
}
</style>
